'use client';

import { c as _c } from "react/compiler-runtime";
import { useGetUser, useGetUserStreak } from '@morfi/backend-sdk-v2/client';
import { useEffect, useState } from 'react';
import { logger } from '@/lib/telemetry/logger';
import { StreakCalendarSheet } from './streak-calendar-sheet';
import { StreakLevelsSheet } from './streak-levels-sheet';
import { StreakWidgetView } from './streak-widget-view';
import { StreaksHowItWorksDialog } from './streaks-how-it-works-dialog';
import { useStreakDay } from './use-streak-day';
interface StreakWidgetProps {
  userId: string;
  walletPubkeys?: readonly string[];
}

/** Portfolio streak card — fetches the streak and renders the presentational view. */
export function StreakWidget(t0) {
  const $ = _c(34);
  const {
    userId,
    walletPubkeys
  } = t0;
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [levelsOpen, setLevelsOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  let t1;
  if ($[0] !== walletPubkeys) {
    t1 = walletPubkeys ?? [];
    $[0] = walletPubkeys;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["currentStreak", "longestStreak", "streakLastLocalDate"];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== userId) {
    t3 = {
      identifier: userId,
      walletPubkeys: t1,
      fields: t2
    };
    $[3] = t1;
    $[4] = userId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data
  } = useGetUser(t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["timezone"];
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== userId) {
    t5 = {
      identifier: userId,
      fields: t4
    };
    $[7] = userId;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    data: streak,
    error
  } = useGetUserStreak(t5);
  const today = useStreakDay(streak?.timezone);
  const todayComplete = today === null || data === undefined ? null : data.streakLastLocalDate === today;
  let t6;
  let t7;
  if ($[9] !== error || $[10] !== userId) {
    t6 = () => {
      if (error) {
        logger.error("streak.summary_load_failed", {
          userId,
          error: String(error)
        });
      }
    };
    t7 = [error, userId];
    $[9] = error;
    $[10] = userId;
    $[11] = t6;
    $[12] = t7;
  } else {
    t6 = $[11];
    t7 = $[12];
  }
  useEffect(t6, t7);
  const currentStreak = data?.currentStreak ?? 0;
  const t8 = data?.longestStreak ?? 0;
  let t10;
  let t11;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setCalendarOpen(true);
    t10 = () => setLevelsOpen(true);
    t11 = () => setHelpOpen(true);
    $[13] = t10;
    $[14] = t11;
    $[15] = t9;
  } else {
    t10 = $[13];
    t11 = $[14];
    t9 = $[15];
  }
  let t12;
  if ($[16] !== currentStreak || $[17] !== helpOpen || $[18] !== t8 || $[19] !== todayComplete) {
    t12 = <StreakWidgetView currentStreak={currentStreak} longestStreak={t8} todayComplete={todayComplete} onViewCalendar={t9} onViewLevels={t10} onShowHelp={t11} helpOpen={helpOpen} browseHref="/markets" />;
    $[16] = currentStreak;
    $[17] = helpOpen;
    $[18] = t8;
    $[19] = todayComplete;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== calendarOpen || $[22] !== userId) {
    t13 = <StreakCalendarSheet userId={userId} open={calendarOpen} onOpenChange={setCalendarOpen} />;
    $[21] = calendarOpen;
    $[22] = userId;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== currentStreak || $[25] !== levelsOpen) {
    t14 = <StreakLevelsSheet currentStreak={currentStreak} open={levelsOpen} onOpenChange={setLevelsOpen} />;
    $[24] = currentStreak;
    $[25] = levelsOpen;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== helpOpen) {
    t15 = <StreaksHowItWorksDialog open={helpOpen} onOpenChange={setHelpOpen} />;
    $[27] = helpOpen;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t12 || $[30] !== t13 || $[31] !== t14 || $[32] !== t15) {
    t16 = <div className="flex h-full min-w-0 flex-col">{t12}{t13}{t14}{t15}</div>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  return t16;
}